module.exports = " <navbar></navbar> <section class=page-content> <search :placeholder=placeholder choose=视频></search> </section> <foot></foot> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/views/Video.vue
 ** module id = 86
 ** module chunks = 0
 **/